// NPM Imports
import React from "react";
import ReactDOM from "react-dom";
// import amplitude from "amplitude-js";
import { LicenseManager } from "ag-grid-enterprise";
import { pdfjs } from "react-pdf";
import * as Sentry from "@sentry/browser";
// import registerServiceWorker from "./registerServiceWorker";

// Internal Imports
import App from "./app";
import "./fontawesome";
import "./index.scss";
import TagManager from "./gtm";

const amplitude =
  typeof window !== "undefined" ? require("amplitude-js") : null;

// Declarations;
let DEFAULT_AMPLITUDE_ENDPOINT = "";
if (typeof window !== "undefined") {
  DEFAULT_AMPLITUDE_ENDPOINT = `${window.location.hostname}/analytics/`;
}

const AMPLITUDE_ENDPOINT = `${
  process.env.REACT_APP_AMPLITUDE_API_ENDPOINT || DEFAULT_AMPLITUDE_ENDPOINT
}`;

if (module.hot) {
  module.hot.accept();
}

// * PASS LICENSE KEY TO AG-GRID
LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_SECRET_KEY);

// * TO SERVER REACT-PDF WORKER.JS FILE FROM CDN, THE BELOW CONFIGURATION IS SET
pdfjs.GlobalWorkerOptions.workerSrc =
  process.env.REACT_APP_REACT_PDF_SERVICE_WORKER_URL;

// * INITIALIZE SENTRY ONLY FOR PRODUCTION
if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DNS,
    environment: process.env.REACT_APP_ENVIRONMENT,
    maxBreadcrumbs: 15,
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "Request failed with status code 400",
    ],
  });

  // Pass user email to all sentry events
  const user = JSON.parse(localStorage.getItem("revvsalesUser"));
  Sentry.setUser({ email: (user && user.user_email) || "" });
  Sentry.setExtra("app_version", process.env.REACT_APP_VERSION);
}

// * INITIALIZE AMPLITUDE
if (typeof window !== "undefined") {
  try {
    amplitude.getInstance().init(process.env.REACT_APP_AMPLITUDE_APPID, null, {
      apiEndpoint: `${AMPLITUDE_ENDPOINT}`,
    });
  } catch (err) {
    console.error(`Amplitude Init => src/index.js => ${err}`);
  }
}
// try {
//   const user = JSON.parse(localStorage.getItem("revvsalesUser"));
//   if (user && user.user_oid) {
//     amplitude.setUserId(user.user_oid);
//   }
// } catch (err) {
//   console.error(`reset user id on Load/Init => src/index.js => ${err}`);
// }

// Init google tag manager
let tagMangerObj = { gtmId: process.env.REACT_APP_GTM_CONTAINER_ID };
try {
  const user = JSON.parse(localStorage.getItem("revvsalesUser"));
  if (user && user.user_oid) {
    tagMangerObj = {
      ...tagMangerObj,
      dataLayer: {
        userId: user.user_oid,
      },
    };
  }
} catch (err) {
  console.debug("TagManager: unable to get user id when init");
}

TagManager.initialize(tagMangerObj);

ReactDOM.render(<App />, document.getElementById("root"));
// registerServiceWorker();

// Logic to check and set the theme to the app
(function () {
  const rootElement = document.getElementById("root");
  const isDarkMode = JSON.parse(localStorage.getItem("darkMode"));
  if (isDarkMode) {
    rootElement.className = "theme--dark";
  } else {
    localStorage.setItem("darkMode", false);
    rootElement.className = "theme--light";
  }
})();

// TODO: Use the below code so set the className of the theme
// _toggleAppTheme = () => {
//   const rootElement = document.getElementById("root");
//   const isDarkMode = JSON.parse(localStorage.getItem("darkMode"));
//   rootElement.className = `theme--${isDarkMode ? "dark" : "light"}`;
//   localStorage.setItem("darkMode", !isDarkMode);
// };
